import { ColumnCenter, Row, RowCenter } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled from "styled-components"

import { ReactComponent as ArrowRight2Svg } from 'assets/svgs/arrow_right_2.svg'
import { ReactComponent as BalanceSvg } from 'assets/svgs/balance.svg'
import { shortStr } from "utils"
import { getWalletLogo } from "utils/walletManage"
import { useCallback, useEffect, useState } from "react"
import CopyToClipboard from "react-copy-to-clipboard"
import { setStore } from "utils/store"
import CImage from "components/CImage"
import BitCoinIcon from 'assets/brc20/btc_chain.png'
import { useOkxBitcoinWallet } from "hooks/wallet/useOkxBitcoinWalletProvider"

interface Props {
    disconnectChange: () => void
}

const OkxDetailCom = ({disconnectChange} : Props) => {
    const { address, disconnected } = useOkxBitcoinWallet()

    const fnDisconnect = useCallback(() => {
        try {
            disconnected()
            disconnectChange()
            setStore('chainge.curWallet', '')
        } catch(error) {
            
        }
    }, [disconnectChange, disconnected])

    const [isCopy, setIsCopy] = useState(false);
    useEffect(() => {
      if (isCopy) {
        setTimeout(() => {
          setIsCopy(false);
        }, 2000);
      }
    }, [isCopy]);

    return <>
        <CardWrap>
                <UserAccountInfoWrap>
                    <WalletImgWrap src={getWalletLogo('OkxWallet')}></WalletImgWrap>
                    <StyledContainer $mt="10px" $mb="21px" $fontSize="16px" $fontWeight6 $lineHeight="18px" $roobertSemiBold>OkxWallet</StyledContainer>
                    <CopyToClipboard text={address || ''}
                        onCopy={() => setIsCopy(true)}
                    >
                        <AddressBarWrap>
                            {
                                shortStr(address || '')
                            }
                            <CopyBtnWrap>{isCopy ? "Copied" : 'Copy'}</CopyBtnWrap>
                        </AddressBarWrap>
                    </CopyToClipboard>
                    
                    <StyledContainer $height="8px"></StyledContainer>

                    <ChainItemCom width="170px"></ChainItemCom>

                    <StyledContainer $height="30px"></StyledContainer>
                    <Row $justifyContent="space-between" $width="100%">
                        <Row>
                            <BalanceSvgWrap></BalanceSvgWrap>
                            <BalanceTextWrap $ml="6px">Balance</BalanceTextWrap>
                        </Row>
                        <BalanceTextWrap>{(+('0.00')).toFixed(4)} BTC</BalanceTextWrap>
                    </Row>
                </UserAccountInfoWrap>
                <RowCenter>
                    <DisconnectBtnWrap onClick={fnDisconnect}>Disconnect</DisconnectBtnWrap>
                </RowCenter>
            </CardWrap>
    </>
}

interface ChainItemProps {
    width: string
    $mb?: string,
}
const ChainItemCom = ({width, $mb='0px'} : ChainItemProps) => {
    return <ChainItemWrap $width={width} $mb={$mb}>
        <Row>
            <CImage width="18px" height="18px" mr="8px" src={BitCoinIcon}></CImage>
            <ChainNameWrap>BitCoin</ChainNameWrap>
        </Row>
        <ArrowRight2SvgWrap></ArrowRight2SvgWrap>
    </ChainItemWrap>
}


const CardWrap = styled(StyledContainer)`
    border-radius: 9px;
    background: ${({theme}) => theme.basicWhite};

    box-shadow: 0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12);
`

const UserAccountInfoWrap = styled(ColumnCenter)`
    padding: 20px 17px 8px;
    border-bottom: 1px solid #F2F2F2;
`

const WalletImgWrap = styled.img`
    width: 26px;
    height: 26px;
`

const AddressBarWrap = styled(RowCenter)`
    border-radius: 12px;
    background: #F6F5F4;
    padding: 4px 6px;

    font-size: 12px;
    font-weight: 500;
    line-height: 1;
`

const CopyBtnWrap = styled(RowCenter)`
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    font-family: RoobertRegular;
    color: ${({theme}) => theme.basicPurple};
    padding: 3px 6px;
    border-radius: 4px;
    background: ${({theme}) => theme.basicWhite};
    margin-left: 8px;
    cursor: pointer;
`

// 切换链
const ChainItemWrap = styled(Row)`
    padding: 12px;
    border-radius: 12px;
    background: #F6F5F4;

    justify-content:space-between;
    cursor: pointer;

    box-sizing: border-box;
`

const ChainNameWrap = styled(StyledContainer)`
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    font-family: RoobertSemiBold;
`
const BalanceSvgWrap = styled(BalanceSvg)`
`

const BalanceTextWrap = styled(StyledContainer)`
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    font-family: RoobertRegular;
    color: #767A7F;
`

const DisconnectBtnWrap = styled(StyledContainer)`

    border-radius: 12px;
    background:  #FFF3F4;
    padding: 9px 8px;

    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    font-family: RoobertSemiBold;

    color: #DF2935;
    cursor: pointer;

    margin: 18px auto 20px;
`

const ArrowRight2SvgWrap = styled(ArrowRight2Svg)`
    width: 12px;
    height: 12px;
    path {
        fill: ${({theme}) => theme.basicBlack};
    }
`

export default OkxDetailCom